import React from 'react';
import * as S from '../styles';
import KitTeam from '../components/KitTeam';

export default function KitSelector({ ...props }) {
  return (
    <S.KitSelectorContainer>
      <KitTeam {...props} />
    </S.KitSelectorContainer>
  );
}
